import ActionsForm from '@/shared/mixins/actionsForm'
import addSpecialRisks from '../addSpecialRisks/addSpecialRisks.vue'
import APRTemplateRiscosEspeciaisRepository from '@/shared/http/repositories/business/aprSpecialRisks'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  props: ['aprId', 'revisao', 'aprTemplateReprovado', 'templateClonado'],
  name: 'specialRiskTable',
  components: {addSpecialRisks},
  mixins: [ActionsForm],
  data () {
    return {
      columTemplate: ['RISCO ESPECIAL', 'STATUS', 'TIPO DE MUDANÇA', 'DATA DE CADASTRO', ''],
      dataRiscoEspecialTemplateAPR: [],
      dataRiscoEspecialBusca: {}
    }
  },
  watch: {
    templateClonado (newValue) {
      if (newValue !== null || newValue !== undefined) {
        this.dataRiscoEspecialBusca = {APRId: newValue.id, Revisao: newValue.revisao}
        APRTemplateRiscosEspeciaisRepository.GetAPRTemplateRiscosEspeciaisGrid(this.$refs.tableGridsTemplateAprRiscoEspecial.pagingLimit, this.$refs.tableGridsTemplateAprRiscoEspecial.pagingIndex, this.dataRiscoEspecialBusca)
          .then((Response) => {
            loading.pop()
            this.dataRiscoEspecialTemplateAPR = Response.data.data
          }).catch(Error => {
            loading.pop()
            toast.error('Erro ao carregar as informações')
          })
      }
    }
  },
  methods: {
    popUptAddRiscoEspecial () {
      this.$refs['add-riscoEspecial'].show()
    },
    cancelarRiscoEspecial () {
      this.$refs['add-riscoEspecial'].hide()
    },
    onLoad (value) {
      if (this.revisao !== -1 || value != null) {
        loading.push()
        if (value !== undefined && value !== null) {
          this.dataRiscoEspecialBusca = {APRId: this.aprId, Revisao: value}
          APRTemplateRiscosEspeciaisRepository.GetAPRTemplateRiscosEspeciaisGrid(this.$refs.tableGridsTemplateAprRiscoEspecial.pagingLimit, this.$refs.tableGridsTemplateAprRiscoEspecial.pagingIndex, this.dataRiscoEspecialBusca)
            .then((Response) => {
              loading.pop()
              this.$refs.tableGridsTemplateAprRiscoEspecial.LoadAllByData(Response)
              this.dataRiscoEspecialTemplateAPR = Response.data.data
            }).catch(Error => {
              loading.pop()
            })
        } else {
          this.dataRiscoEspecialBusca = {APRId: this.aprId, Revisao: this.revisao}
          APRTemplateRiscosEspeciaisRepository.GetAPRTemplateRiscosEspeciaisGrid(this.$refs.tableGridsTemplateAprRiscoEspecial.pagingLimit, this.$refs.tableGridsTemplateAprRiscoEspecial.pagingIndex, this.dataRiscoEspecialBusca)
            .then((Response) => {
              loading.pop()
              this.$refs.tableGridsTemplateAprRiscoEspecial.LoadAllByData(Response)
              this.dataRiscoEspecialTemplateAPR = Response.data.data
            }).catch(Error => {
              loading.pop()
            })
        }
      }
    },
    AdicionarTableRiscoEspecial (value) {
      this.dataRiscoEspecialTemplateAPR.push(...value)
      this.$refs['add-riscoEspecial'].hide()
    },
    DeletePopup (value) {
      loading.push()
      if (value.AgEnvio !== undefined && value.AgEnvio !== null && value.AgEnvio !== false) {
        this.dataRiscoEspecialTemplateAPR = this.dataRiscoEspecialTemplateAPR.filter(riscoEspecialId => riscoEspecialId.riscosEspeciaisId !== value.riscosEspeciaisId)
        this.$emit('removerListaDeAlteracoesRiscosEspeciais', value)
        loading.pop()
      } else {
        for (let i = 0; i < this.dataRiscoEspecialTemplateAPR.length; i++) {
          if (this.dataRiscoEspecialTemplateAPR[i].riscosEspeciaisId === value.riscosEspeciaisId) {
            this.dataRiscoEspecialTemplateAPR[i].statusAprovacao = null
            this.dataRiscoEspecialTemplateAPR[i].statusAprovacaoDescricao = 'AG. ENVIO'
            this.dataRiscoEspecialTemplateAPR[i].tipoMudanca = 'AG. ENVIO EXCLUSÃO'
            this.dataRiscoEspecialTemplateAPR[i].dateCricaoFormatada = null
            let dados = {
              APRId: this.aprId,
              riscosEspeciais: value.riscosEspeciaisId,
              APRAgAprovacaoId: value.arpTemplateAgAprovacaoId
            }
            this.$emit('excluirRiscoEspecial', dados)
          }
        }
        loading.pop()
      }
      loading.pop()
    },
    salvarRiscoEspecial (valeu) {
      this.$emit('salvarRiscoEspecial', valeu)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/specialRisks/specialRisks.js